import DashboardTypes from './dashboard.types';
import { decodeApiResponse, docodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE = {
	// DASHBOARD CARD DETAILS
	getDashBoardCardDetailsResponse: null,
	getDashboardCardDetailsArr: [],

	// REJECT MEMBER LIST
	getRejectMemberListArr: [],
	getRejectMemberListStatus: null,

	// LOAN DETAILS
	loanDetailsFetchResponse: null,
	getLoanDetailsArr: [],

	// LOAN INDEX DETAILS
	loanIndexDetailsFetchResponse: null,
	getLoanIndexDetailsArr: [],

	//PARTICULAR DATE DEMAND
	getParticularDateDemandArr: [],
	getParticularDateDemandStatus: null,

	// PARTICULAR DATE COLLECTION
	getParticularDateCollectionArr: [],
	getParticularDateCollectionStatus: null,

	// PARTICULAR DATE DEMAND INFO
	getParticularDateDemandInfoArr: [],
	getParticularDateDemandInfoStatus: null,

	//PARTICULAR DATE MEMBER ABSENT
	getParticularDateMemberAbsentArr: [],
	getParticularDateMemberAbsentStatus: null,

	// WEEK COLLECTION
	getWeekCollectionArr: [],
	getWeekCollectionResponse: null,
	getWeekCollectionStatus: null,

	// WEEK YET TO DO COLLECTION
	getWeekYTCollectionArr: [],
	// getWeekYTCollectionResponse: null,
	getWeekYTCollectionStatus: null,

	// ARREAR COLLECTION
	getArrearCollectionListStatus: null,
	getArrearCollectionListArr: [],

	// LOAN TYPE
	dashboardDetailsLoanTypeFetchResponse: null,
	getDashboardDetailsLoanTypeArr: [],

	// EOD STATUS
	companyEodStatusResponse: null,
	getCompanyEodStatusArr: [],

	// PARTICULAR LIST
	getDashboardParticularListArr: [],
	getDashboardParticularListStatus: null,

	// STAFF COLLECTION
	getDashboardStaffCollectionArr: [],
	getDashboardStaffCollectionStatus: null,

	// STAFF LOCATION
	getDashboardStaffLocationArr: [],
	getDashboardStaffLocationStatus: null,

	// SMS USED LIST
	getSMSUsedListStatus: null,
	getSMSUsedListArr: [],

	// KYC USED LIST
	getKYCUsedListStatus: null,
	getKYCUsedListArr: [],

	// STAFF MAP COLLECTION
	getDashboardStaffMapCollectionStatus: null,
	getDashboardStaffMapCollectionArr: [],

	// COLLECTION INFO
	getDashboardCollectionInfoStatus: null,
	getDashboardCollectionInfoArr: [],

	// Savings And FD
	getDashBoardSavingsAndFdResp: null,
	getDashBoardSavingsAndFdArr: [],

	// Branch Total Investment Amount
	getBranchTotalInvestmentAmountArr: [],
	getBranchTotalInvestmentAmountResp: null,

	// Dashboard Total Branch Member
	getDashboardTotalBranchMemberArr: [],
	getDashboardTotalBranchMemberResp: null,

	getBranchTotalOLBAmountArr: [],
	getBranchTotalOLBAmountResp: null,

	getTotalCollectionArr: [],
	getTotalCollectionResp: null,

	getDashboardAmountBasedonlocationArr: [],
	getDashboardAmountBasedonlocationResp: null,

	getDashboardZeroCollectionDetailsArr: [],
	getDashboardZeroCollectionDetailsResp: null,

	getOnlineStaffDetailsResp: null,
	getOnlineStaffDetailsArr: [],

	getOfficerLiveStatusResp: null,
	getOfficerLiveStatusArr: [],

	// Gold Loan Card Details
	getGoldLoanCardDetailsResponse: null,
	getGoldLoanCardDetailsArr: [],

	// Gold Loan Dashboard Loan Details
	goldLoanDashboardLoanDetailsFetchResponse: null,
	getGoldLoanDashboardLoanDetailsArr: [],

	// Gold Loan Loan Index Details
	getGoldLoanLoanIndexDetailsResponse: null,
	getGoldLoanLoanIndexDetailsArr: [],
};

const dashboardReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************** GET DASHBOARD CARD DETAILS START ***************************** */
		case DashboardTypes.GET_DASHBOARD_CARD_DETAILS_SUCCESS:
			return {
				...state,
				getDashBoardCardDetailsResponse: action.payload,
				getDashboardCardDetailsArr: docodeHexResponse(
					action.payload,
					'DashboardCardDetailsFetchKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_CARD_DETAILS_FAILURE:
			return {
				...state,
				getDashBoardCardDetailsResponse: action.payload,
				getDashboardCardDetailsArr: [],
			};

		case DashboardTypes.GET_DASHBOARD_CARD_DETAILS_RESPONSE_CHANGED:
			return { ...state, getDashBoardCardDetailsResponse: null };

		/****************** GET DASHBOARD CARD DETAILS END ***************************** */

		/** *********************  GET REJECT MEMBER LIST START ******************** */
		case DashboardTypes.REJECT_MEMBER_LIST_SUCCESS:
			return {
				...state,
				getRejectMemberListStatus: action.payload,
				getRejectMemberListArr: docodeHexResponse(
					action.payload,
					'RejectedMembersDetailsKey',
				),
			};

		case DashboardTypes.REJECT_MEMBER_LIST_FAILURE:
			return {
				...state,
				getRejectMemberListStatus: action.payload,
			};

		case DashboardTypes.REJECT_MEMBER_LIST_CHANGED:
			return { ...state, getRejectMemberListStatus: null };

		/** *********************  GET REJECT MEMBER LIST END ******************** */

		/** *********************  GET LOAN DETAILS LIST START ******************** */
		case DashboardTypes.GET_LOAN_DETAILS_SUCCESS:
			return {
				...state,
				loanDetailsFetchResponse: action.payload,
				getLoanDetailsArr: docodeHexResponse(action.payload, 'DashboardLoanDeatilsKey'),
			};

		case DashboardTypes.GET_LOAN_DETAILS_FAILURE:
			return {
				...state,
				loanDetailsFetchResponse: action.payload,
				getLoanDetailsArr: [],
			};

		case DashboardTypes.GET_LOAN_DETAILS_RESPONSE_CHANGED:
			return { ...state, loanDetailsFetchResponse: null };

		/** *********************  GET LOAN DETAILS LIST END ******************** */

		/** *********************  GET LOAN INDEX DETAILS LIST START ******************** */
		case DashboardTypes.GET_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				loanIndexDetailsFetchResponse: action.payload,
				getLoanIndexDetailsArr: docodeHexResponse(
					action.payload,
					'DashboardLoanIndexDetailsKey',
				),
			};

		case DashboardTypes.GET_LOAN_INDEX_DETAILS_FAILURE:
			return {
				...state,
				loanIndexDetailsFetchResponse: action.payload,
				getLoanIndexDetailsArr: [],
			};

		case DashboardTypes.GET_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, loanIndexDetailsFetchResponse: null };

		/** *********************  GET LOAN INDEX DETAILS LIST END ******************** */

		/** **********  GET DASHBOARD PARTICULAR DATE DEMAND LIST START ************ */
		case DashboardTypes.GET_PARTICULAR_DATE_DEMAND_SUCCESS:
			return {
				...state,
				getParticularDateDemandStatus: action.payload,
				getParticularDateDemandArr: docodeHexResponse(
					action.payload,
					'ParticularDateGroupDemandInfoKey',
				),
			};

		case DashboardTypes.GET_PARTICULAR_DATE_DEMAND_FAILURE:
			return {
				...state,
				getParticularDateDemandStatus: action.payload,
			};

		case DashboardTypes.GET_PARTICULAR_DATE_DEMAND_CHANGED:
			return {
				...state,
				getParticularDateDemandStatus: null,
				getParticularDateDemandArr: null,
			};

		/** ********** GET DASHBOARD PARTICULAR DATE DEMAND LIST START ************* */

		/** ********** GET DASHBOARD PARTICULAR DATE DEMAND INFO START ************* */
		case DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_SUCCESS:
			return {
				...state,
				getParticularDateDemandInfoStatus: action.payload,
				getParticularDateDemandInfoArr: docodeHexResponse(
					action.payload,
					'ParticularDateGroupMemberInfoKey',
				),
			};

		case DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_FAILURE:
			return {
				...state,
				getParticularDateDemandInfoStatus: action.payload,
			};

		case DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_CHANGED:
			return {
				...state,
				getParticularDateDemandInfoStatus: null,
				getParticularDateDemandInfoArr: null,
			};
		/** ********** GET DASHBOARD PARTICULAR DATE DEMAND INFO END ************* */

		/** ********** GET DASHBOARD PARTICULAR DATE MEMBER ABSENT INFO START ************* */
		case DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_SUCCESS:
			return {
				...state,
				getParticularDateMemberAbsentStatus: action.payload,
				getParticularDateMemberAbsentArr: docodeHexResponse(
					action.payload,
					'DashboardMemberAbsentDetailsKey',
				),
			};

		case DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_FAILURE:
			return {
				...state,
				getParticularDateMemberAbsentStatus: action.payload,
			};

		case DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_CHANGED:
			return {
				...state,
				getParticularDateMemberAbsentStatus: null,
				getParticularDateMemberAbsentArr: null,
			};

		/** ********** GET DASHBOARD PARTICULAR DATE MEMBER ABSENT INFO END ************* */

		/** ********** GET DASHBOARD PARTICULAR DATE COLLECTION START ************* */
		case DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_SUCCESS:
			return {
				...state,
				getParticularDateCollectionStatus: action.payload,
				getParticularDateCollectionArr: docodeHexResponse(
					action.payload,
					'DashboardParticularDateGroupCollectionKey',
				),
			};

		case DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_FAILURE:
			return {
				...state,
				getParticularDateCollectionStatus: action.payload,
			};

		case DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_CHANGED:
			return {
				...state,
				getParticularDateCollectionStatus: null,
				getParticularDateCollectionArr: null,
			};

		/** ********** GET DASHBOARD PARTICULAR DATE COLLECTION END ************* */

		/** ********** GET DASHBOARD PARTICULAR DATE COLLECTION INFO START ************* */
		case DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_SUCCESS:
			return {
				...state,
				getParticularDateCollectionInfoStatus: action.payload,
				getParticularDateCollectionInfoArr: docodeHexResponse(
					action.payload,
					'GetParticularDateGroupMemberCollectionKey',
				),
			};

		case DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_FAILURE:
			return {
				...state,
				getParticularDateCollectionInfoStatus: action.payload,
			};

		case DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_CHANGED:
			return {
				...state,
				getParticularDateCollectionInfoStatus: null,
				getParticularDateCollectionInfoArr: null,
			};

		/** ********** GET DASHBOARD PARTICULAR DATE COLLECTION INFO END ************* */

		/** ********** GET WEEK PCOLLECTION INFO START ************* */
		case DashboardTypes.GET_WEEK_COLLECTION_SUCCESS:
			return {
				...state,
				getWeekCollectionStatus: action.payload,
				getWeekCollectionArr: docodeHexResponse(
					action.payload,
					'CollectionAmountBranchMemberWiseKey',
				),
				getWeekCollectionResponse: decodeApiResponse(
					action.payload.response,
					'CollectionAmountBranchMemberWiseKey',
				),
			};

		case DashboardTypes.GET_WEEK_COLLECTION_FAILURE:
			return {
				...state,
				getWeekCollectionStatus: action.payload,
			};

		case DashboardTypes.GET_WEEK_COLLECTION_CHANGED:
			return {
				...state,
				getWeekCollectionStatus: null,
				getWeekCollectionArr: null,
			};

		/** ********** GET WEEK PCOLLECTION INFO END ************* */

		/** ********** GET WEEK PCOLLECTION INFO START ************* */
		case DashboardTypes.GET_WEEK_YT_COLLECTION_SUCCESS:
			return {
				...state,
				getWeekYTCollectionStatus: action.payload,
				getWeekYTCollectionArr: docodeHexResponse(
					action.payload,
					'GetParticularCollectionPendingGroupMemberKey',
				),
				// getWeekYTCollectionResponse: decodeApiResponse(
				// 	action.payload.response,
				// 	'GetParticularCollectionPendingGroupMemberKey',
				// ),
			};

		case DashboardTypes.GET_WEEK_YT_COLLECTION_FAILURE:
			return {
				...state,
				getWeekYTCollectionStatus: action.payload,
			};

		case DashboardTypes.GET_WEEK_YT_COLLECTION_CHANGED:
			return {
				...state,
				getWeekYTCollectionStatus: null,
			};

		/** ********** GET WEEK PCOLLECTION INFO END ************* */

		/** ********** GET ARREAR COLLECTION LIST START ************* */
		case DashboardTypes.ARREAR_COLLECTION_LIST_SUCCESS:
			return {
				...state,
				getArrearCollectionListStatus: action.payload,
				getArrearCollectionListArr: docodeHexResponse(
					action.payload,
					'DashboardArrearCollectionListKey',
				),
			};

		case DashboardTypes.ARREAR_COLLECTION_LIST_FAILURE:
			return {
				...state,
				getArrearCollectionListStatus: action.payload,
			};

		case DashboardTypes.ARREAR_COLLECTION_LIST_CHANGED:
			return {
				...state,
				getArrearCollectionListStatus: null,
			};
		/** ********** GET ARREAR COLLECTION LIST END ************* */

		/** ********** GET COLLECTION NOTES INFO START ************* */
		case DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_SUCCESS:
			return {
				...state,
				getDashboardCollectionInfoStatus: action.payload,
				getDashboardCollectionInfoArr: docodeHexResponse(
					action.payload,
					'GetCollectionNotesInfoKey',
				),
			};

		case DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_FAILURE:
			return {
				...state,
				getDashboardCollectionInfoStatus: action.payload,
			};

		case DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_CHANGED:
			return {
				...state,
				getDashboardCollectionInfoStatus: null,
			};
		/** ********** GET COLLECTION NOTES INFO END ************* */

		/** ********** GET LOAN TYPE FETCH START ************* */

		case DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_SUCCESS:
			return {
				...state,
				dashboardDetailsLoanTypeFetchResponse: action.payload,
				getDashboardDetailsLoanTypeArr: docodeHexResponse(
					action.payload,
					'DashboardDetailsLoanTypeKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_FAILURE:
			return {
				...state,
				dashboardDetailsLoanTypeFetchResponse: action.payload,
				getDashboardDetailsLoanTypeArr: [],
			};

		case DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_RESPONSE_CHANGED:
			return { ...state, dashboardDetailsLoanTypeFetchResponse: null };

		/** ********** GET LOAN TYPE FETCH END ************* */

		/** ********** GET EOD STATUS START ************* */

		case DashboardTypes.COMPANY_EOD_STATUS_SUCCESS:
			return {
				...state,
				companyEodStatusResponse: action.payload,
				getCompanyEodStatusArr: docodeHexResponse(
					action.payload,
					'GetCompanyEndOfDayStatusKey',
				),
			};

		case DashboardTypes.COMPANY_EOD_STATUS_FAILURE:
			return {
				...state,
				companyEodStatusResponse: action.payload,
				getCompanyEodStatusArr: [],
			};

		case DashboardTypes.COMPANY_EOD_STATUS_RESPONSE_CHANGED:
			return { ...state, companyEodStatusResponse: null };

		/** ********** GET EOD STATUS END ************* */

		/** ********** GET PARTICULAR DETAILS START ************* */
		case DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_SUCCESS:
			return {
				...state,
				getDashboardParticularListStatus: action.payload,
				getDashboardParticularListArr: docodeHexResponse(
					action.payload,
					'DashboardCardBranchwiseKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_FAILURE:
			return {
				...state,
				getDashboardParticularListStatus: action.payload,
			};

		case DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_CHANGED:
			return { ...state, getDashboardParticularListStatus: null };

		/** ********** GET PARTICULAR DETAILS END ************* */

		/** ********** GET STAFF COLLECTION START ************* */
		case DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_SUCCESS:
			return {
				...state,
				getDashboardStaffCollectionStatus: action.payload,
				getDashboardStaffCollectionArr: docodeHexResponse(
					action.payload,
					'StaffTotalcollectionKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_FAILURE:
			return {
				...state,
				getDashboardStaffCollectionStatus: action.payload,
			};

		case DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_CHANGED:
			return { ...state, getDashboardStaffCollectionStatus: null };

		/** ********** GET STAFF COLLECTION END ************* */

		/** ********** GET STAFF LOCATION START ************* */
		case DashboardTypes.GET_STAFF_LOCATION_SUCCESS:
			return {
				...state,
				getDashboardStaffLocationStatus: action.payload,
				getDashboardStaffLocationArr: docodeHexResponse(
					action.payload,
					'GetCompanyBasedOnStaffLocationKey',
				),
			};

		case DashboardTypes.GET_STAFF_LOCATION_FAILURE:
			return {
				...state,
				getDashboardStaffLocationStatus: action.payload,
			};

		case DashboardTypes.GET_STAFF_LOCATION_CHANGED:
			return { ...state, getDashboardStaffLocationStatus: null };
		/** ********** GET STAFF LOCATION END ************* */

		/** ********** GET PARTICULAR DETAILS START ************* */

		case DashboardTypes.SMS_USED_LIST_SUCCESS:
			return {
				...state,
				getSMSUsedListStatus: action.payload,
				getSMSUsedListArr: docodeHexResponse(action.payload, 'DashboardSMSUsedListKey'),
			};

		case DashboardTypes.SMS_USED_LIST_FAILURE:
			return {
				...state,
				getSMSUsedListStatus: action.payload,
			};

		case DashboardTypes.SMS_USED_LIST_CHANGED:
			return {
				...state,
				getSMSUsedListStatus: null,
			};
		/** ********** GET PARTICULAR DETAILS START ************* */

		/** ********** GET KYC USED LIST START ************* */
		case DashboardTypes.KYC_USED_LIST_SUCCESS:
			return {
				...state,
				getKYCUsedListStatus: action.payload,
				getKYCUsedListArr: docodeHexResponse(action.payload, 'DashboardKYCUsedListKey'),
			};

		case DashboardTypes.KYC_USED_LIST_FAILURE:
			return {
				...state,
				getKYCUsedListStatus: action.payload,
			};

		case DashboardTypes.KYC_USED_LIST_CHANGED:
			return {
				...state,
				getKYCUsedListStatus: null,
			};
		/** ********** GET KYC USED LIST START ************* */

		/** ********** GET STAFF MAP COLLECTION START ************* */
		case DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_SUCCESS:
			return {
				...state,
				getDashboardStaffMapCollectionStatus: action.payload,
				getDashboardStaffMapCollectionArr: docodeHexResponse(
					action.payload,
					'DashboardStaffMapCollectionKey',
				),
			};

		case DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_FAILURE:
			return {
				...state,
				getDashboardStaffMapCollectionStatus: action.payload,
			};

		case DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_CHANGED:
			return {
				...state,
				getDashboardStaffMapCollectionStatus: null,
			};
		/** ********** GET STAFF MAP COLLECTION END ************* */

		/***************** Get Dashboard Savind And FD Details *******************/
		case DashboardTypes.GET_DASHBOARD_SAVINGS_FD_SUCCESS:
			return {
				...state,
				getDashBoardSavingsAndFdResp: action.payload,
				getDashBoardSavingsAndFdArr: docodeHexResponse(
					action.payload,
					'getDashBoardSavingsAndFDKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_SAVINGS_FD_FAILURE:
			return {
				...state,
				getDashBoardSavingsAndFdResp: action.payload,
			};

		case DashboardTypes.GET_DASHBOARD_SAVINGS_FD_CHANGED:
			return {
				...state,
				getDashBoardSavingsAndFdResp: null,
			};

		/*********** Get Dashboard Savind And FD Details ***************/

		/***************** Get Dashboard Total Branch Member *******************/
		case DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_SUCCESS:
			return {
				...state,
				getDashboardTotalBranchMemberResp: action.payload,
				getDashboardTotalBranchMemberArr: docodeHexResponse(
					action.payload,
					'GetDashboardTotalBranchMemberKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_FAILURE:
			return {
				...state,
				getDashboardTotalBranchMemberResp: action.payload,
			};

		case DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_CHANGED:
			return {
				...state,
				getDashboardTotalBranchMemberResp: null,
			};
		/*********** Get Dashboard Total Branch Member ***************/

		/***************** Get Branch Total Investment Amount *******************/
		case DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_SUCCESS:
			return {
				...state,
				getBranchTotalInvestmentAmountResp: action.payload,
				getBranchTotalInvestmentAmountArr: docodeHexResponse(
					action.payload,
					'GetBranchTotalInvestmentAmountKey',
				),
			};

		case DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_FAILURE:
			return {
				...state,
				getBranchTotalInvestmentAmountResp: action.payload,
			};

		case DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_CHANGED:
			return {
				...state,
				getBranchTotalInvestmentAmountResp: null,
			};
		/*********** Get Branch Total Investment Amount ***************/

		/***************** Get Branch Total OLB Amount *******************/
		case DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_SUCCESS:
			return {
				...state,
				getBranchTotalOLBAmountResp: action.payload,
				getBranchTotalOLBAmountArr: docodeHexResponse(
					action.payload,
					'GetBranchTotalOLBAmountKey',
				),
			};

		case DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_FAILURE:
			return {
				...state,
				getBranchTotalOLBAmountResp: action.payload,
			};

		case DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_CHANGED:
			return {
				...state,
				getBranchTotalOLBAmountResp: null,
			};
		/*********** Get Branch Total OLB Amount ***************/

		/***************** Get Total Collection *******************/
		case DashboardTypes.GET_TOTAL_COLLECTION_SUCCESS:
			return {
				...state,
				getTotalCollectionResp: action.payload,
				getTotalCollectionArr: docodeHexResponse(
					action.payload,
					'GetTotalCollectionAmountKey',
				),
			};

		case DashboardTypes.GET_TOTAL_COLLECTION_FAILURE:
			return {
				...state,
				getTotalCollectionResp: action.payload,
			};

		case DashboardTypes.GET_TOTAL_COLLECTION_CHANGED:
			return {
				...state,
				getTotalCollectionResp: null,
			};
		/*********** Get Total Collection ***************/

		case DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_SUCCESS:
			return {
				...state,
				getDashboardAmountBasedonlocationResp: action.payload,
				getDashboardAmountBasedonlocationArr: docodeHexResponse(
					action.payload,
					'GetDashboardDetailsBasedonLocKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_FAILURE:
			return {
				...state,
				getDashboardAmountBasedonlocationResp: action.payload,
			};

		case DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_CHANGED:
			return {
				...state,
				getDashboardAmountBasedonlocationResp: null,
			};

		case DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getDashboardZeroCollectionDetailsResp: action.payload,
				getDashboardZeroCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'getDashBoardZeroCollectionKey',
				),
			};

		case DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_FAILURE:
			return {
				...state,
				getDashboardZeroCollectionDetailsResp: action.payload,
			};

		case DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_CHANGED:
			return {
				...state,
				getDashboardZeroCollectionDetailsResp: null,
			};

		case DashboardTypes.GET_ONLINE_STAFF_DETAILS_SUCCESS:
			return {
				...state,
				getOnlineStaffDetailsResp: action.payload,
				getOnlineStaffDetailsArr: docodeHexResponse(
					action.payload,
					'getOnlineStaffDetailsKey',
				),
			};

		case DashboardTypes.GET_ONLINE_STAFF_DETAILS_FAILURE:
			return {
				...state,
				getOnlineStaffDetailsResp: action.payload,
			};

		case DashboardTypes.GET_ONLINE_STAFF_DETAILS_CHANGED:
			return {
				...state,
				getOnlineStaffDetailsResp: null,
			};

		case DashboardTypes.GET_OFFICER_LIVE_STATUS_SUCCESS:
			return {
				...state,
				getOfficerLiveStatusResp: action.payload,
				getOfficerLiveStatusArr: docodeHexResponse(action.payload, 'OfficerLiveStatusKey'),
			};

		case DashboardTypes.GET_OFFICER_LIVE_STATUS_FAILURE:
			return {
				...state,
				getOfficerLiveStatusResp: action.payload,
				getOfficerLiveStatusArr: [],
			};

		case DashboardTypes.GET_OFFICER_LIVE_STATUS_CHANGED:
			return {
				...state,
				getOfficerLiveStatusResp: null,
			};
		/** ********** GET GOLD LOAN CARD DETAILS START ************* */
		case DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_SUCCESS:
			return {
				...state,
				getGoldLoanCardDetailsResponse: action.payload,
				getGoldLoanCardDetailsArr: docodeHexResponse(
					action.payload,
					'GoldLoanCardDetailsFetchKey',
				),
			};

		case DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_FAILURE:
			return {
				...state,
				getGoldLoanCardDetailsResponse: action.payload,
				getGoldLoanCardDetailsArr: [],
			};

		case DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_RESPONSE_CHANGED:
			return { ...state, getGoldLoanCardDetailsResponse: null };
		/** ********** GET GOLD LOAN CARD DETAILS END ************* */

		/** ********** GET GOLD LOAN DASHBOARD LOAN DETAILS START ************* */
		case DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_SUCCESS:
			return {
				...state,
				goldLoanDashboardLoanDetailsFetchResponse: action.payload,
				getGoldLoanDashboardLoanDetailsArr: docodeHexResponse(
					action.payload,
					'GoldLoanDashboardLoanDetailsKey',
				),
			};

		case DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_FAILURE:
			return {
				...state,
				goldLoanDashboardLoanDetailsFetchResponse: action.payload,
				getGoldLoanDashboardLoanDetailsArr: [],
			};

		case DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_RESPONSE_CHANGED:
			return { ...state, goldLoanDashboardLoanDetailsFetchResponse: null };
		/** ********** GET GOLD LOAN DASHBOARD LOAN DETAILS END ************* */

		/** ********** GET GOLD LOAN LOAN INDEX DETAILS START ************* */
		case DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				getGoldLoanLoanIndexDetailsResponse: action.payload,
				getGoldLoanLoanIndexDetailsArr: docodeHexResponse(
					action.payload,
					'GoldLoanLoanIndexDetailsKey',
				),
			};

		case DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_FAILURE:
			return {
				...state,
				getGoldLoanLoanIndexDetailsResponse: action.payload,
				getGoldLoanLoanIndexDetailsArr: [],
			};

		case DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, getGoldLoanLoanIndexDetailsResponse: null };
		/** ********** GET GOLD LOAN LOAN INDEX DETAILS END ************* */

		default:
			return state;
	}
};

export default dashboardReducer;
